module.exports = __webpack_public_path__ + "media/images/redesign-images/icons/icon-chat-heart-42f6e3c346cff98e661afa90256081ed.svg";